module.exports = __webpack_public_path__ + "img/icn-spec__controller--pro.5ef9a143.svg";